import Axios, { AxiosInstance, AxiosRequestConfig, AxiosError } from 'axios';
import LocalAuth from '@shamrock-core/common/authentication/local-authentication';
import gk2 from '@shamrock-core/gk2';
import { FF, getIsTrial, isFeatureEnabled, redirectToLogout } from '../utils/utils';

export abstract class ServiceBase {
  protected axios: AxiosInstance;
  constructor(url: string) {
    this.createAxios(url);
  }
  protected abstract createAxios(url: string): void;
}

export default class Service extends ServiceBase {
  skipLogout = false;
  constructor(serviceUrl: string) {
    super(serviceUrl);
  }

  protected createAxios(url: string): void {
    let token;
    let headers;

    try {
      token = LocalAuth.getTokenValue();
    } catch (e) { }
    if (token) {
      headers = {
        Authorization: `Bearer ${token}`,
      };
    }

    this.axios = Axios.create({
      baseURL: url,
      headers: headers,
    });
  }

  async addInterceptors(tokenGenerator: () => Promise<string>, loginWithRedirect: () => Promise<void>) {
    this.axios.interceptors.request.use(
      async (config: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
        const token = LocalAuth.getTokenValue();
        const deviceId = localStorage.getItem('device_id');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
          return gk2.webInterceptor(config, getIsTrial(token), deviceId);
        } else if (tokenGenerator) {
          const generatedToken = await tokenGenerator();
          config.headers.Authorization = `Bearer ${generatedToken}`;
        }
        return config;
      },
      (error: AxiosError): Promise<AxiosError> => Promise.reject(error),
    );

    this.axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (!this.skipLogout && (error?.response?.status === 401 || error?.response?.status === 403)) {
          const isAuth0Enabled = isFeatureEnabled(FF.AUTH0);
          if (isAuth0Enabled) {
            LocalAuth.clearStorage();
            await loginWithRedirect();
          } else {
            redirectToLogout();
          }
        }
        this.skipLogout = false;
        return Promise.reject(error);
      },
    );
  }
}

export class NoAuthService extends ServiceBase {
  constructor(url: string) {
    super(url);
  }

  protected createAxios(url: string): void {
    this.axios = Axios.create({
      baseURL: url,
    });
  }
}
